import { AccredibleButtonComponentModule } from '@accredible-frontend-v2/new-components/button';
import { A11yModule } from '@angular/cdk/a11y';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { MobilePopUpComponent } from './mobile-pop-up.component';
import { PopUpMenuTriggerDirective } from './mobile-pop-up.directive';
import { MobilePopUpService } from './mobile-pop-up.service';

@NgModule({
  imports: [
    CommonModule,
    OverlayModule,
    A11yModule,
    TranslocoModule,
    AccredibleButtonComponentModule,
    MatIconModule,
  ],
  exports: [MobilePopUpComponent, PopUpMenuTriggerDirective],
  declarations: [MobilePopUpComponent, PopUpMenuTriggerDirective],
  providers: [MobilePopUpService],
})
export class MobilePopUpComponentModule {}
